export const amenitiesReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_AMENITIES_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        amenities: null,
      };
    case "GET_AMENITIES_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        amenities: action.payload,
      };
    case "GET_AMENITIES_LIST_FAILED":
      return {
        ...state,
        loading: false,
        amenities: action.payload,
      };
    case "GET_SUB_AMENITIES_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        subAmenities: null,
      };
    case "GET_SUB_AMENITIES_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        subAmenities: action.payload,
      };
    case "GET_SUB_AMENITIES_LIST_FAILED":
      return {
        ...state,
        loading: false,
        subAmenities: action.payload,
      };
    case "GET_AMENITY_REQUEST":
      return {
        ...state,
        loading: true,
        amenity: null,
      };
    case "GET_AMENITY_SUCCESS":
      return {
        ...state,
        loading: false,
        amenity: action.payload,
      };
    case "GET_AMENITY_FAILED":
      return {
        ...state,
        loading: false,
        amenity: action.payload,
      };
    case "ADD_AMENITIES_REQUEST":
      return {
        ...state,
        loading: true,
        amenities: null,
      };
    case "ADD_AMENITIES_SUCCESS":
      return {
        ...state,
        loading: false,
        amenities: action.payload,
      };
    case "ADD_AMENITIES_FAILED":
      return {
        ...state,
        loading: false,
        amenities: action.payload,
      };
    default:
      return state;
  }
};
